/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseListString } from '../models/api-response-list-string';
import { disabled } from '../fn/guide-setting-client-api/disabled';
import { Disabled$Params } from '../fn/guide-setting-client-api/disabled';

@Injectable({ providedIn: 'root' })
export class GuideSettingClientApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `disabled()` */
  static readonly DisabledPath = '/v1/api/guide-setting-client/disabled';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `disabled()` instead.
   *
   * This method doesn't expect any request body.
   */
  disabled$Response(params?: Disabled$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListString>> {
    return disabled(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `disabled$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  disabled(params?: Disabled$Params, context?: HttpContext): Observable<ApiResponseListString> {
    return this.disabled$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListString>): ApiResponseListString => r.body)
    );
  }

}
